(function () {
  'use strict';

  function getFocusableStepTarget(step) {
    return step.querySelector('[data-partner-step-heading]') || step.querySelector('legend, h2, h3');
  }

  function validateSelectionGroups(scope) {
    var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-require-selection]'));

    return groups.every(function (group) {
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"], input[type="radio"]'));
      if (!inputs.length) return true;

      var isValid = inputs.some(function (input) {
        return input.checked;
      });
      inputs[0].setCustomValidity(isValid ? '' : 'Please select at least one option.');

      if (!isValid) {
        inputs[0].reportValidity();
      }

      return isValid;
    });
  }

  function validateScope(scope) {
    var requiredControls = Array.prototype.slice.call(scope.querySelectorAll('[required]'));

    for (var index = 0; index < requiredControls.length; index += 1) {
      var control = requiredControls[index];
      if (!control.checkValidity()) {
        control.reportValidity();
        return false;
      }
    }

    return validateSelectionGroups(scope);
  }

  function bindSelectionGroups(root) {
    root.querySelectorAll('[data-require-selection]').forEach(function (group) {
      var inputs = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');

      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (Array.prototype.some.call(inputs, function (candidate) { return candidate.checked; })) {
            inputs[0].setCustomValidity('');
          }
        });
      });
    });
  }

  function bindConditionalFields(root) {
    root.querySelectorAll('[data-conditional-trigger]').forEach(function (trigger) {
      var targetId = trigger.getAttribute('data-conditional-trigger');
      var target = root.querySelector('#' + targetId);
      if (!target) return;

      var relatedRadios = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]')).filter(function (radio) {
        return radio.name === trigger.name;
      });

      function update() {
        var shouldShow = trigger.checked && trigger.value === 'Yes';
        target.hidden = !shouldShow;
        target.querySelectorAll('input, textarea, select').forEach(function (control) {
          control.disabled = !shouldShow;
        });
      }

      relatedRadios.forEach(function (radio) {
        radio.addEventListener('change', update);
      });
      update();
    });
  }

  function bindMultiStepForm(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-partner-step]'));
    if (!steps.length) return;

    var progressLabel = root.querySelector('[data-partner-progress-label]');
    var progressBar = root.querySelector('[data-partner-progress-bar]');
    var currentStep = 0;

    function showStep(nextStep, shouldFocus) {
      currentStep = Math.max(0, Math.min(nextStep, steps.length - 1));

      steps.forEach(function (step, index) {
        step.hidden = index !== currentStep;
        step.setAttribute('aria-hidden', index === currentStep ? 'false' : 'true');
      });

      if (progressLabel) {
        progressLabel.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;
      }

      if (progressBar) {
        progressBar.style.width = (((currentStep + 1) / steps.length) * 100) + '%';
      }

      if (shouldFocus) {
        var target = getFocusableStepTarget(steps[currentStep]);
        if (target) {
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: false });
        }
      }
    }

    root.querySelectorAll('[data-partner-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!validateScope(steps[currentStep])) return;
        showStep(currentStep + 1, true);
      });
    });

    root.querySelectorAll('[data-partner-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        showStep(currentStep - 1, true);
      });
    });

    showStep(0, false);
  }

  function bindFormValidation(form) {
    form.addEventListener('submit', function (event) {
      if (!validateSelectionGroups(form)) {
        event.preventDefault();
      }
    });
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-partner-inquiry]').forEach(function (inquiry) {
      if (inquiry.getAttribute('data-partner-ready') === 'true') return;
      inquiry.setAttribute('data-partner-ready', 'true');

      bindSelectionGroups(inquiry);
      bindConditionalFields(inquiry);
      bindMultiStepForm(inquiry);

      inquiry.querySelectorAll('form').forEach(bindFormValidation);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
